module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-section mt-32"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("희망 활동처")]), _vm._v(" "), _c('ul', {
    staticClass: "check-list"
  }, [_c('li', [_c('div', {
    staticClass: "activity-item"
  }, [_c('span', {
    staticClass: "th-name"
  }, [_vm._v("1순위")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "title": _vm.title + ' 1순위 입력',
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.wishComp1
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "activity-item"
  }, [_c('span', {
    staticClass: "th-name"
  }, [_vm._v("2순위")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "title": _vm.title + ' 2순위 입력',
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.wishComp2
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "activity-item"
  }, [_c('span', {
    staticClass: "th-name"
  }, [_vm._v("3순위")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "title": _vm.title + ' 3순위 입력',
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.wishComp3
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91e4b452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/WishCompanySection.vue
// module id = 1482
// module chunks = 6